import { render, staticRenderFns } from "./ScopeEvaluationPanel.vue?vue&type=template&id=2b6a5d28&scoped=true"
import script from "./ScopeEvaluationPanel.vue?vue&type=script&lang=js"
export * from "./ScopeEvaluationPanel.vue?vue&type=script&lang=js"
import style0 from "./ScopeEvaluationPanel.vue?vue&type=style&index=0&id=2b6a5d28&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a5d28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6a5d28')) {
      api.createRecord('2b6a5d28', component.options)
    } else {
      api.reload('2b6a5d28', component.options)
    }
    module.hot.accept("./ScopeEvaluationPanel.vue?vue&type=template&id=2b6a5d28&scoped=true", function () {
      api.rerender('2b6a5d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope/ScopeEvaluationPanel.vue"
export default component.exports